import { api } from "../client";

export const putComplianceOverride = (id, body) => {
  return api.put(`/ComplianceOverride/${id}`, body);
};
